module.exports = __webpack_public_path__ + "img/mergdata_digi_variation_1.8a8962f5.png";